import { render, staticRenderFns } from "./IngredientsList.vue?vue&type=template&id=6173f064&scoped=true&"
import script from "./IngredientsList.vue?vue&type=script&lang=ts&"
export * from "./IngredientsList.vue?vue&type=script&lang=ts&"
import style0 from "./IngredientsList.vue?vue&type=style&index=0&id=6173f064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6173f064",
  null
  
)

export default component.exports